import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {

  constructor(
    private router: Router
  ) { }

  logout() {
    localStorage.removeItem('authorization');
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts